
.input {
  all: unset;
  min-width: 0;
  padding: 0 1ch;
}

.iconSearch {
  padding-left: 1ch;
  display: flex;
  align-items: center;
}

.iconSelect {
  padding-right: 1ch;
}

.autocomplete {
  position: relative;
  user-select: none;
  border-radius: 8px;
  background-color: var(--secondary-enabled);
  border: 1px solid var(--static-divider-standard);
}
.autocompleteInvalid {
  border: 1px solid var(--sentiment-text-negative);
}
.autocomplete:hover {
  background-color: var(--static-background-standard);
}
.autocomplete:active {
  background-color: var(--static-background-standard);
}
.autocomplete:not(.autocompleteInvalid):not(.autocomplete:disabled):focus-within {
  border: 1px solid var(--primary-enabled);
}
.autocomplete:disabled {
  filter: grayscale(100%);
  opacity: 0.6;
  cursor: not-allowed;
}

.fullWidth {
  width: 100%;
}

.dropdown {
  min-width: max-content;
  overflow: hidden auto;
  background-color: var(--static-background-weak);
  border: 1px solid var(--static-divider-standard);
  border-radius: 10px;
  box-shadow: var(--box-shadow);
}
.dropdownItem {
  min-width: 10rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 5px;
  padding: 8px;
  border-radius: 10px;
}
.dropdownItem:hover, .dropdownItem.dropdownItemKeyboardHovered {
  cursor: pointer;
  background-color: var(--selectable-hover);
}

.fullWidth {
  width: 100%;
}
